import { render, staticRenderFns } from "./SMSManagePushShipper.vue?vue&type=template&id=21029b2e"
import script from "./SMSManagePushShipper.vue?vue&type=script&lang=js"
export * from "./SMSManagePushShipper.vue?vue&type=script&lang=js"
import style0 from "./SMSManagePushShipper.vue?vue&type=style&index=0&id=21029b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports